import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetLineItem } from "../queries/lineItems";
import { ENTITY } from "../constants";

export const LineItemBreadcrumb = ({ match }) => {
  // Entity
  const { LINEITEM } = ENTITY;

    const {
      data: lineItem,
      isLoading,
      isError,
      error,
    } = useGetLineItem(match.params.lineItemId);
  
    if (isLoading) {
      //return <span>Loading...</span>;
      return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
    }
  
    if (isError && error instanceof NotFoundException) {
      return <span>Not found</span>;
    }
  
    if (lineItem) {
      return <span>{trimString(lineItem[LINEITEM.nameField], 20)}</span>;
    }
  
    return null;
  };